// extracted by mini-css-extract-plugin
export var video = "RichTextVideo-module--video--716ca";